import { render, staticRenderFns } from "./DictionaryGrid.vue?vue&type=template&id=50a19d82&"
import script from "./DictionaryGrid.vue?vue&type=script&lang=js&"
export * from "./DictionaryGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports